/**
 * Smooth a grid-based A* path to remove staircase artifacts from
 * 8-connected grid movement. Applies Chaikin's corner cutting.
 */
export function smoothGridPath(path: [number, number][]): [number, number][] {
  if (path.length < 4) return path
  return chaikinSmooth(path, 1)
}

function chaikinSmooth(points: [number, number][], iterations: number): [number, number][] {
  let pts = points
  for (let iter = 0; iter < iterations; iter++) {
    if (pts.length < 3) break
    const next: [number, number][] = [pts[0]]
    for (let i = 0; i < pts.length - 1; i++) {
      const [x1, y1] = pts[i]
      const [x2, y2] = pts[i + 1]
      next.push([x1 * 0.75 + x2 * 0.25, y1 * 0.75 + y2 * 0.25])
      next.push([x1 * 0.25 + x2 * 0.75, y1 * 0.25 + y2 * 0.75])
    }
    next.push(pts[pts.length - 1])
    pts = next
  }
  return pts
}
